
import {pkceChallengeFromVerifier, stripOauthParamsFromUrl } from '../keycloack/authentication';

const keycloakServer = import.meta.env.VITE_PUBLIC_AUTH_KEYCLOAK_SERVER_URL;
const clientId = import.meta.env.VITE_PUBLIC_AUTH_KEYCLOAK_CLIENT_ID;
const realm = import.meta.env.VITE_PUBLIC_AUTH_KEYCLOAK_REALM;
const keycloakBaseUrl = `${keycloakServer}/auth/realms/${realm}/protocol/openid-connect`;
export const LOGOUT_DELETE_COOKIES_QUERY_PARAM = 'logout_delete_cookies';
export const createLoginURL = async (redirectUri: string, pkceCodeVerifier: string) => {
  const url = new URL(`${keycloakBaseUrl}/auth`);
  url.searchParams.append('client_id', clientId);
  url.searchParams.append('response_type', 'code');
  url.searchParams.append('redirect_uri', stripOauthParamsFromUrl(redirectUri));
  url.searchParams.append('scope', 'openid');
  url.searchParams.append('code_challenge_method', 'S256');
  url.searchParams.append('code_challenge',await pkceChallengeFromVerifier(pkceCodeVerifier));

  return  url.toString();
};

export const getAccessToken = async (
  username: string,
  password: string,
) => {
  const url = new URL(`${keycloakBaseUrl}/token`);
  const body = new URLSearchParams();
  body.append('grant_type', 'password');
  body.append('username',username)
  body.append('password',password)
  body.append('client_id', clientId);
  body.append('scope', 'openid')

  const response = await fetch(url.toString(), {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: body.toString(),
  });

  const data = await response.json();
  return data;
};

export const refreshAccessToken = async (
  refreshToken: string,
  redirectUri: string,
) => {
  const url = `${keycloakBaseUrl}/token`;
  const body = new URLSearchParams();
  body.append('grant_type', 'refresh_token');
  body.append('client_id', clientId);
  body.append('refresh_token', refreshToken);
  body.append('redirect_uri',stripOauthParamsFromUrl(redirectUri)); 
  body.append('scope', 'openid offline_access')
  try {
    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      body: body.toString(),
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Token refresh error details:', {
        error: errorData.error,
        error_description: errorData.error_description,
        request: {
          url,
          client_id: clientId,
          redirect_uri: redirectUri,
          refresh_token: refreshToken,
        },
      });
      throw new Error(`Token refresh failed: ${errorData.error_description}`);
    }

    const data = await response.json();
    console.log('Refresh token response:', data);
    return data;
  } catch (error) {
    console.error('Error refreshing token:', error);
    throw error;
  }
};

export const buildLogoutUrl = (redirectUri: string, id_token_hint?: string) => {
  if (!id_token_hint) return '';
  const redirectUrl = new URL(redirectUri);
  redirectUrl.searchParams.append(LOGOUT_DELETE_COOKIES_QUERY_PARAM, 'true');

  const logoutUrl = new URL(`${keycloakBaseUrl}/logout`);
  logoutUrl.searchParams.append('client_id', clientId);
  logoutUrl.searchParams.append('id_token_hint', id_token_hint);
  logoutUrl.searchParams.append('post_logout_redirect_uri', redirectUrl.toString());

  return logoutUrl.toString();
};